import { getRestakeApy } from "@services/index";
import { useQuery } from "@tanstack/react-query";

export function useRestakeApy() {
  return useQuery({
    queryKey: ["restake-apy"],
    queryFn: async () => {
      return (await getRestakeApy()).data;
    },
  });
}
